/* eslint-disable @typescript-eslint/naming-convention */
import { PASSWORD_REGEX, SPECIAL_CHARACTER_REGEX } from '../../definitions/regex';
import {
  CrudFormConfig,
  CrudFormTextBoxItem,
  CrudViewFormItemType,
  TextBoxType,
  FormLayout,
  CrudFormInputValidatorInfoItem,
  InputSize,
  FeedbackButtonActionBehavior,
  IconComponentConfig,
  IconType,
  ButtonType
} from '@rappider/rappider-components/utils';
import { Validators } from '@angular/forms';
import { PATH_DEFINITIONS } from '@rappider/shared/definitions';

export const RESET_PASSWORD_CONFIG: CrudFormConfig = {
  items: [
    <CrudFormTextBoxItem>{
      title: 'SHARED.NEW_PASSWORD',
      fieldName: 'password',
      type: CrudViewFormItemType.TextBox,
      textType: TextBoxType.Password,
      size: InputSize.Large,
      placeholder: 'SHARED.PASSWORD',
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.REQUIRED_FIELD_MESSAGE'
        },
        {
          type: Validators.pattern(PASSWORD_REGEX),
          errorKey: 'pattern'
        }
      ]
    },
    <CrudFormInputValidatorInfoItem>{
      relatedFieldName: 'password',
      type: CrudViewFormItemType.InputValidatorInfo,
      patternInfos: [
        {

          pattern: /[1-9]/,
          message: 'ERRORS.PATTERN_MESSAGES.PASSWORD_PATTERN_MESSAGES.ONE_DIGIT'
        },
        {
          pattern: /[A-Z]/,
          message: 'ERRORS.PATTERN_MESSAGES.PASSWORD_PATTERN_MESSAGES.ONE_UPPERCASE'
        },
        {
          pattern: SPECIAL_CHARACTER_REGEX,
          message: 'ERRORS.PATTERN_MESSAGES.PASSWORD_PATTERN_MESSAGES.SPECIAL_CHARACTER'
        },
        {
          pattern: /.{8,}/,
          message: 'ERRORS.PATTERN_MESSAGES.PASSWORD_PATTERN_MESSAGES.MINIMUM_LENGTH'
        }
      ]
    },
    <CrudFormTextBoxItem>{
      title: 'SHARED.CONFIRM_PASSWORD',
      fieldName: 'confirmPassword',
      type: CrudViewFormItemType.TextBox,
      textType: TextBoxType.Password,
      size: InputSize.Large,
      placeholder: 'SHARED.CONFIRM_PASSWORD',
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.REQUIRED_FIELD_MESSAGE'
        },
        {
          errorKey: 'mustMatch',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.MUST_MATCH_PASSWORD'
        }
      ]
    }
  ],
  validators: [
    {
      name: 'MustMatch',
      validatorKey: 'mustMatch',
      params: {
        field1: 'password',
        field2: 'confirmPassword'
      }
    }
  ],
  itemSettings: {
    labelComponentSize: {
      xs: 24
    },
    inputComponentSize: {
      xs: 24
    },
  },
  formLayout: FormLayout.Vertical,
  submitButton: {
    text: 'AUTHENTICATION_MODULE.RESET_PASSWORD_COMPONENT.RESET_PASSWORD',
    size: 'large',
    type: ButtonType.Primary
  }
};

export const RAPPIDER_RESET_PASSWORD_SUCCESS_FEEDBACK_CONFIG = {
  title: 'SHARED.DONE!',
  icon: <IconComponentConfig>{
    name: 'far fa-check-circle text-success',
    type: IconType.FontAwesome,
    color: 'green'
  },
  description: 'Your password has been changed successfully.',
  buttons: [
    {
      content: 'SHARED.GO_TO_LOGIN_PAGE',
      actionBehavior: FeedbackButtonActionBehavior.Route,
      redirectUrl: PATH_DEFINITIONS.AUTH.LOGIN_PATH
    }
  ]
};


export const RAPPIDER_RESET_PASSWORD_FAILURE_FEEDBACK_CONFIG = {
  title: 'Oops!',
  icon: <IconComponentConfig>{
    name: 'fas fa-exclamation-triangle text-danger',
    type: IconType.FontAwesome,
    color: 'red'
  },
  description: 'We couldn\'t change your password.',
  buttons: [
    {
      content: 'SHARED.GO_TO_LOGIN_PAGE',
      actionBehavior: FeedbackButtonActionBehavior.Route,
      redirectUrl: PATH_DEFINITIONS.AUTH.LOGIN_PATH
    }
  ]
};
